class QuickviewProductFlavor extends HTMLElement {

  constructor() {
    // Always call super first in constructor
    super();
    var _this = this;
    console.log(_this.parentNode)
    this.flavorContainers = _this.querySelectorAll('.flavor-container');
    this.packSizeInputs = _this.parentNode.querySelectorAll('[data-option="Size"]');
    this.addNewToCart = _this.parentNode.querySelector('[data-add-to-cart]');
    this.addNewToCart.classList.add('disabled')

    _this.maxQuantity = 0; // Initialize maxQuantity
    _this.selectedFlavorInput = null; // Declare selectedFlavorInput variable
    _this.totalSelectedFlavors = 0;
    _this.flavorQuantities = [];

    _this.flavorContainers.forEach(container => {
      container.dataset.maxQuantity = _this.packSizeInputs.length ? _this.maxQuantity : 4;
    });

    if (_this.packSizeInputs.length) {
      _this.packSizeInputs.forEach(input => {
        if (input.checked) {
          _this.maxQuantity = input.value.toLowerCase().split(" ").find(function(t) {
            return parseInt(t) > 0
          });
          _this.maxQuantity = parseInt(_this.maxQuantity)
        }
      });

      _this.packSizeInputs.forEach(input => {
        input.addEventListener('change', () => {
          _this.maxQuantity = input.value.toLowerCase().split(" ").find(function(t) {
            return parseInt(t) > 0
          });
          _this.maxQuantity = parseInt(_this.maxQuantity)
          _this.resetFlavorQuantities(); // Reset flavor quantities when changing pack size
          _this.updatePropertiesInput();
          _this.updateAddToCartButtonState();
        });
      });
    } else {
      _this.maxQuantity = 4;
    }

    _this.flavorContainers.forEach(container => {
      _this.selectedFlavorInput = container.querySelector('.selectedFlavor'); // Assign selectedFlavorInput
      const variantId = _this.selectedFlavorInput.getAttribute('data-variant');
      const flavorButton = container.querySelector('.flavorSelectionButton');
      const flavorName = flavorButton.getAttribute('data-flavor');

      // Check if the flavor is already in the flavorQuantities array
      const flavorIndex = _this.flavorQuantities.findIndex(item => item.flavor === flavorName);

      if (flavorIndex === -1) {
        _this.flavorQuantities.push({variant: variantId, flavor: flavorName, quantity: 0});
      }

      const incrementButton = container.querySelector('.incrementQuantity');
      const decrementButton = container.querySelector('.decrementQuantity');
      const quantityLabel = container.querySelector('.quantityLabel');

      incrementButton.addEventListener('click', () => {
        const flavorQuantity = _this.flavorQuantities.find(item => item.flavor === flavorName);
        const addFlavor = _this.canAddFlavor(flavorName);
        if (addFlavor) {
          flavorQuantity.quantity += 1;
          _this.totalSelectedFlavors += 1;
          quantityLabel.textContent = flavorQuantity.quantity.toString();

          _this.updatePropertiesInput();
          _this.updateButtonStyle(container, flavorQuantity.quantity);
          _this.updateAddToCartButtonState();
        }
      });

      decrementButton.addEventListener('click', () => {
        const flavorQuantity = _this.flavorQuantities.find(item => item.flavor === flavorName);

        if (flavorQuantity && flavorQuantity.quantity > 0) {
          flavorQuantity.quantity -= 1;
          _this.totalSelectedFlavors -= 1;
          quantityLabel.textContent = flavorQuantity.quantity.toString();

          _this.updatePropertiesInput();
          _this.updateButtonStyle(container, flavorQuantity.quantity);
          _this.updateAddToCartButtonState();
        }
      });
    });

    _this.updateAddToCartButtonState();
  }

  canAddFlavor(flavor) {
    const flavorQuantity = this.flavorQuantities.find(item => item.flavor === flavor);
    const selectedFlavorsCount = this.flavorQuantities.reduce((total, item) => total + item.quantity, 0);
    return flavorQuantity && flavorQuantity.quantity < this.maxQuantity && selectedFlavorsCount < this.maxQuantity;
  }

  selectedPackSize() {
    const selectedPackInput = this.parentNode.querySelector('[data-option="Size"]:checked');
    return selectedPackInput
      ? selectedPackInput.value.toLowerCase().split(" ").find(function(t) {
        return parseInt(t) > 0
      })
      : ''
  }

  updatePropertiesInput() {
    let properties = '';
    for (const flavorQuantity of this.flavorQuantities) {
      if (flavorQuantity.quantity > 0) {
        properties += `${
          flavorQuantity.quantity
        }, `;
      }
    }
    if (this.selectedFlavorInput) {
      this.selectedFlavorInput.value = properties.slice(0, -2);
    }

    var _this = this;
    var flavorQuantitiesFinal = _this.flavorQuantities.filter(item => item.quantity > 0)
    var flavorQuantitiesFinalItems = [];
    for (const item of _this.flavorQuantities) {
      if (item.quantity > 0) {
        flavorQuantitiesFinalItems.push(`${item.flavor} (${item.quantity})`)
      }
    }
    var flavorQuantitiesFinalItemsStr = '';
    if (flavorQuantitiesFinalItems.length > 0) {
      flavorQuantitiesFinalItemsStr = flavorQuantitiesFinalItems.join(", ");
    }
    const addToCartForm = _this.parentNode.querySelector('[data-product-form]');
    if (addToCartForm.querySelector('input[name="properties[Flavors]"]')) {
      addToCartForm.querySelector('input[name="properties[Flavors]"]').value = flavorQuantitiesFinalItemsStr;
    } else {
      var flavorPropertiesInput = document.createElement("input");
      flavorPropertiesInput.type = "hidden";
      flavorPropertiesInput.value = flavorQuantitiesFinalItemsStr;
      flavorPropertiesInput.name = "properties[Flavors]";
      addToCartForm.appendChild(flavorPropertiesInput)
    }
  }

  updateButtonStyle(container, quantity) {
    if (quantity > 0) {
      container.classList.add('active');
    } else {
      container.classList.remove('active');
    }
  }

  updateAddToCartButtonState() {
    const disabled = this.totalSelectedFlavors !== this.maxQuantity || this.totalSelectedFlavors === 0
    if (disabled) {
      this.addNewToCart.classList.add('disabled')
    } else {
      this.addNewToCart.classList.remove('disabled')
    }
  }

  resetFlavorQuantities() {
    var _this = this
    _this.totalSelectedFlavors = 0;
    _this.flavorQuantities.forEach(item => {
      item.quantity = 0;
      let container;
      for (const flavorContainer of _this.flavorContainers) {
        const flavorButton = flavorContainer.querySelector('.flavorSelectionButton');
        if (flavorButton.getAttribute('data-flavor') === item.flavor) {
          container = flavorContainer;
          break;
        }
      }
      if (container) {
        _this.updateButtonStyle(container, 0);
        const quantityLabel = container.querySelector('.quantityLabel');
        quantityLabel.textContent = '0';
      }
    });

    // Reset the selectedFlavorInput value
    if (_this.selectedFlavorInput) {
      _this.selectedFlavorInput.value = '';
    }

    _this.updateAddToCartButtonState();
  }

  connectedCallback() {
    console.log("Custom element added to page.");
  }

  disconnectedCallback() {
    console.log("Custom element removed from page.");
  }

  adoptedCallback() {
    console.log("Custom element moved to new page.");
  }
}

customElements.define("quickview-product-flavor", QuickviewProductFlavor);